export default{
    data() {
        return {
            breadcrumb: [//面包屑
                {name: "首页", path: "/home"}, 
                {name: "基础数据", path: ""}, 
                {name: "通知公告详情", path: ""}, 
            ],
            apis:{ 
                save: '/oa/noticeInfo/save',//保存信息
                byKey: '/oa/noticeInfo/byKey',//根据信息主键获取信息详情
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传接口
                loadReader:'/oa/noticeReader/allByNoticeKey',
                updateCount:'/oa/noticeInfo/updateCount',
            },
            editObj: {//编辑对象 
                isPutLibrary:0,
                isRelease:0,
                isAffairs:0,
                creator:''
            },    
            noticeKey:null,
            enclosureList: [],  
            readerData:[],
        };
    },
    props: {
        visible: { 
          type: Boolean,
          default: false
        }, 
        noticeKey:String, 
    },
    watch: {
        noticeKey() { 
            this.byKey();
        }, 
    },  
    mounted() {  
    },
    methods: {
        byKey() {
            if(!this.noticeKey || this.noticeKey == '-1' || this.noticeKey == -1){
                return;
            }
            this.$post({
                url: this.apis.byKey,
                params: this.noticeKey
            }).then(rsp => {
                if(!rsp.success){
                    return;
                }
                this.editObj = rsp.retObj; 
                this.enclosureList=rsp.retObj.enclosureList; 
                this.readerNames=rsp.retObj.readerNames;
                this.$delete(this.editObj,'enclosureList');
                this.updateCount();
            });
        }, 
        updateCount(){
            this.$post({
                url: this.apis.updateCount,
                params: this.noticeKey
            }).then(rsp => {
                if(!rsp.success){
                    return;
                }  
                this.loadReader();
            });
        },
        loadReader(){
            if(!this.noticeKey || this.noticeKey == '-1' || this.noticeKey == -1){
                return;
            }
            this.$post({
                url: this.apis.loadReader,
                params: this.noticeKey
            }).then(rsp => {
                if(!rsp.success){
                    return;
                }
                this.readerData = rsp.retObj;  
            });
        },
        goBack() { 
            this.$router.go(-1);  
        }, 
        handlePreview(file){ 
            const url = this.$global.baseUrl + 'sh/file/download?id=' + file.id;
            window.open(url, '_blank');
        },
    },
    
}


// WEBPACK FOOTER //
// ./src/components/oa/view/basics/noticeInfo/view/view.js